import React from 'react';
import { TableRow, TableCell, TableBody } from '@one-thd/sui-atomic-components';
import { Checkmark } from '@one-thd/sui-icons';
import { TableHeader } from './table-header';
export var AccountTableContent = function (_a) {
    var isEnrolled = _a.isEnrolled;
    return (React.createElement(React.Fragment, null,
        React.createElement(TableHeader, { title: "Accounts", showRunner: isEnrolled }),
        React.createElement(TableBody, null,
            React.createElement(TableRow, null,
                React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Manage company address and phone number"),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                isEnrolled && React.createElement(TableCell, { width: "full" })),
            React.createElement(TableRow, null,
                React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Add new users"),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                React.createElement(TableCell, { width: "full" }),
                isEnrolled && React.createElement(TableCell, { width: "full" })),
            React.createElement(TableRow, null,
                React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Edit user permissions"),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                React.createElement(TableCell, { width: "full" }),
                isEnrolled && React.createElement(TableCell, { width: "full" })))));
};
